import type { FormGridItemProps } from '@ace-clublabs/shared-component-library';

type FormGridItemSx = FormGridItemProps['sx'];

export function getRequiredFieldSx(required?: boolean): FormGridItemSx {
  return required
    ? {
        '& .MuiInputLabel-root::after': {
          content: '"*"',
        },
      }
    : undefined;
}

export const defaultInputProps = {
  slotProps: {
    inputLabel: {
      required: false,
    },
  },
};
